<template>
	<div class="height-100dvh">
		<div style="position: fixed; z-index: 1; left: 60px" v-if="LoaderStatus">
			<Spinner />
		</div>
		<header class="mob-back-header justify-content-between pr-3">
			<div class="d-flex align-items-center">
				<img
					class="mr-3"
					@click="goBackToList"
					src="../../assets/mobile/assprog/mobileBackArrow.svg"
					alt=""
				/>
				Interview Report
			</div>
			<b-button
				class="candash-cancelBtn"
				@click="reTakeInterview(mockintMetaData)"
				>Retake</b-button
			>
		</header>
		<main class="re-interview-container">
			<div class="w-100 top-row" :class="{ collapsed: isScrolled }">
				<div id="hideinlaptop" class="fam-lato fw-LM fs-14 text-blue">
					{{ mockintMetaData.interviewName }}
				</div>
				<div
					id="hideinlaptop"
					class="d-flex align-items-center justify-content-between w-100 mt-3"
				>
					<div class="d-flex align-items-center fam-mont fw-LM fs-13">
						<img
							class="mr-2"
							src="../../assets/img/aiInterview/clock.svg"
							alt=""
						/>
						<span class="text-red">{{ mockintMetaData.durationText }}</span>
						<div
							style="height: 20px; width: 1px; background-color: #9eb3c6"
							class="mx-2"
						></div>
						<span
							class="text-capitalize"
							:class="
								mockintMetaData.status == 'aborted'
									? 'color-aborted'
									: 'text-green'
							"
						>
							{{ mockintMetaData.status }}</span
						>
					</div>
					<div class="fam-mont fw-LM fs-12 text-lightgrey">
						{{ formatDateTime(mockintMetaData.startedAt) }}
					</div>
				</div>
				<div
					id="hideinmobile"
					class="d-flex align-items-center justify-content-between"
				>
					<div class="d-flex align-items-center">
						<img
							class="mr-3 d-flex pointer"
							src="../../assets/img/homepage/back-arrow-blue.svg"
							alt=""
							@click="goBackToList"
						/>
						<div>
							<div class="fam-lato fw-LM fs-14 text-darkgrey">
								Interview Name :
							</div>
							<div class="fam-mont fw-M fs-14 text-tertiary mt-1">
								{{ mockintMetaData.interviewName }}
							</div>
						</div>
					</div>
					<div>
						<div class="fam-lato fw-LM fs-14 text-darkgrey">Date & Time:</div>
						<div class="fam-mont fw-M fs-14 text-tertiary mt-1">
							{{ formatDateTime(mockintMetaData.startedAt) }}
						</div>
					</div>
					<div>
						<div class="fam-lato fw-LM fs-14 text-darkgrey">Time Taken:</div>
						<div class="fam-mont fw-M fs-14 text-tertiary mt-1">
							{{ mockintMetaData.durationText }}
						</div>
					</div>
					<div>
						<div class="fam-lato fw-LM fs-14 text-darkgrey">Status:</div>
						<div
							class="fam-mont fw-M fs-14 mt-1 text-capitalize"
							:class="
								mockintMetaData.status == 'aborted'
									? 'color-aborted'
									: 'text-green'
							"
						>
							{{ mockintMetaData.status }}
						</div>
					</div>
					<div>
						<b-button
							class="candash-cancelBtn"
							@click="reTakeInterview(mockintMetaData)"
							>Retake Interview</b-button
						>
					</div>
				</div>
			</div>
			<div
				class="d-flex gap-3 second-row"
				v-if="mockinterviewData.length != 0"
				ref="tabsContainer"
			>
				<article
					v-for="(q, index) in mockinterviewData"
					:key="index"
					:class="{ selected: selectedQuestionIndex === index }"
					@click="scrollToQuestion(index)"
					:ref="`tab-${index}`"
				>
					Question {{ q.questionNumber }}
				</article>
			</div>
			<div
				style="height: calc(100vh - 180px)"
				v-if="!LoaderStatus && mockinterviewData.length == 0"
			>
				<div
					class="d-flex align-items-center justify-content-center flex-column h-100 ml-1 mt-2"
				>
					<img src="@/assets/img/viewinterview/emptymock.svg" alt="" />

					<div class="fam-mont fw-400 fs-16 text-tertiary">
						No Reports were generated
					</div>
				</div>
			</div>
			<div
				v-else
				class="question-overlfow"
				ref="questionOverflow"
				@scroll="handleScroll"
				:style="{
					height: isScrolled ? 'calc(100% - 90px)' : 'calc(100% - 180px)',
				}"
			>
				<div
					v-for="(q, index) in mockinterviewData"
					:key="index"
					class="ques-card"
					:ref="`question-${index}`"
				>
					<div class="d-flex align-items-center gap-2">
						<img
							class="img-1"
							src="../../assets/img/aiInterview/rep-question.svg"
							alt=""
						/>
						<span
							class="fam-lato fw-M fs-16 mob-fs-14 text-383838 white-space-no-wrap"
							>Question {{ q.questionNumber }}</span
						>

						<div
							id="hideinmobile"
							style="height: 20px; width: 1px; background-color: #9eb3c6"
						></div>
						<span id="hideinmobile" class="fam-lato fw-M fs-18 text-darkgrey">
							{{ q.question }}
						</span>
					</div>
					<div
						id="hideinlaptop"
						class="fam-lato fw-M mob-fs-16 text-darkgrey mt-3"
					>
						{{ q.question }}
					</div>
					<div class="dashed-div"></div>
					<div class="answer-card">
						<div
							class="d-flex align-items-center gap-2 fam-lato fw-M fs-16 mob-fs-14 text-blue"
						>
							<img
								class="img-1"
								src="../../assets/img/aiInterview/rep-answer.svg"
								alt=""
							/>Candidate Answer Summary
						</div>
						<p class="fam-lato fw-R fs-16 mob-fs-14 text-black mb-0 mt-2">
							{{ q.answerSummary }}
						</p>
					</div>
					<div class="d-flex align-items-center gap-3 my-3">
						<div class="line"></div>
						<div class="fam-lato fw-M fs-16 mob-fs-14 color-595959">
							Key Insights
						</div>
						<div class="line"></div>
					</div>
					<div
						class="d-flex gap-3 ques-hor-scroll"
						:ref="`aireportHorizontal-${index}`"
					>
						<div class="strength">
							<div
								class="d-flex align-items-center gap-2 fam-mont fw-B fs-18 mob-fs-14 text-green"
							>
								<img
									class="img-1"
									src="../../assets/img/aiInterview/rep-strength.svg"
									alt=""
								/>Strengths
							</div>
							<div class="dashed-div-2"></div>
							<p class="fam-lato fw-R fs-16 mob-fs-14 text-3A3C40 mb-0">
								{{ q.strengths }}
							</p>
						</div>
						<div class="weakness">
							<div
								class="d-flex align-items-center gap-2 fam-mont fw-B fs-18 mob-fs-14 text-blue"
							>
								<img
									class="img-1"
									src="../../assets/img/aiInterview/rep-weak.svg"
									alt=""
								/>Weakness
							</div>
							<div class="dashed-div-2"></div>
							<p class="fam-lato fw-R fs-16 mob-fs-14 text-3A3C40 mb-0">
								{{ q.weakness }}
							</p>
						</div>
						<div class="clarification">
							<div
								class="d-flex align-items-center gap-2 fam-mont fw-B fs-18 mob-fs-16 text-FB923C"
							>
								<img
									class="img-1"
									src="../../assets/img/aiInterview/rep-clar.svg"
									alt=""
								/>Clarification Needed
							</div>
							<div class="dashed-div-2"></div>
							<p class="fam-lato fw-R fs-16 mob-fs-14 text-3A3C40 mb-0">
								{{ q.clarificationNeeded }}
							</p>
						</div>
					</div>
					<div id="hideinlaptop">
						<HorizontalSliderBlog
							v-if="$refs[`aireportHorizontal-${index}`]"
							:scrollContainerRef="$refs[`aireportHorizontal-${index}`][0]"
							:scrollContainerId="`scrollContainer-${index}`"
						/>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import { particularMockInterviewData } from "../../utils/apiFunctions.js";
import HorizontalSliderBlog from "../../components/fixedcomponents/HorizontalScroll.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";

export default {
	data() {
		return {
			isScrolled: false,
			mockinterviewData: [],
			selectedQuestionIndex: 0,
			mockintMetaData: {},
			LoaderStatus: false,
			isAutoScrolling: false,
		};
	},
	components: { Spinner },

	created() {
		this.LoaderStatus = true;
		this.getparticularMockInterviewData();
	},
	mounted() {
		const questionOverflow = this.$refs.questionOverflow;
		if (questionOverflow) {
			questionOverflow.addEventListener("scroll", this.handleScroll);
		}
	},
	components: {
		HorizontalSliderBlog,
	},
	beforeUnmount() {
		const questionOverflow = this.$refs.questionOverflow;
		if (questionOverflow) {
			questionOverflow.removeEventListener("scroll", this.handleScroll);
		}
	},
	methods: {
		scrollActiveTabIntoView(index) {
			this.$nextTick(() => {
				const container = this.$refs.tabsContainer;
				const tab = this.$refs[`tab-${index}`]?.[0];

				if (!container || !tab) return;

				const containerRect = container.getBoundingClientRect();
				const tabRect = tab.getBoundingClientRect();

				// If tab is outside visible area → scroll
				if (
					tabRect.left < containerRect.left ||
					tabRect.right > containerRect.right
				) {
					const scrollLeft =
						container.scrollLeft +
						(tabRect.left - containerRect.left) -
						containerRect.width / 2 +
						tabRect.width / 2;

					container.scrollTo({
						left: scrollLeft,
						behavior: "smooth",
					});
				}
			});
		},
		goBackToList() {
			this.$router.go(-1);
		},
		reTakeInterview(data) {
			this.$store.commit(
				"candidateVUEX/setSelectedSkillsForInterview",
				data.config.skills
			);
			if (data.config.basedOn == "skill") {
				this.$store.commit("candidateVUEX/setSelectedCompany", {});
			} else {
				this.$store.commit("candidateVUEX/setSelectedCompany", {
					company: data.config.company,
					role: data.config.role,
				});
			}
			let query = { fromAiInterview: true };
			if (data.config.basedOn == "skill") {
				query.bySkill = true;
			} else {
				query.byCompany = true;
			}
			this.$router.push({ name: "systemcheck", query: query });
		},
		handleScroll(event) {
			if (this.isAutoScrolling) return; // 🛑 ignore during click-scroll

			const container = event.target;
			const containerRect = container.getBoundingClientRect();

			this.isScrolled = container.scrollTop > 0;

			let activeIndex = 0;

			for (let i = 0; i < this.mockinterviewData.length; i++) {
				const card = this.$refs[`question-${i}`]?.[0];
				if (!card) continue;

				const cardRect = card.getBoundingClientRect();

				if (cardRect.top <= containerRect.top + 20) {
					// 👈 small offset helps accuracy
					activeIndex = i;
				} else {
					break;
				}
			}

			if (activeIndex !== this.selectedQuestionIndex) {
				this.selectedQuestionIndex = activeIndex;
				this.scrollActiveTabIntoView(activeIndex);
			}
		},
		scrollToQuestion(index) {
			this.selectedQuestionIndex = index;
			this.isAutoScrolling = true; // 🔒 lock scroll spy

			this.$nextTick(() => {
				const container = this.$refs.questionOverflow;
				const card = this.$refs[`question-${index}`]?.[0];

				if (!container || !card) return;

				const containerRect = container.getBoundingClientRect();
				const cardRect = card.getBoundingClientRect();

				const scrollTop =
					container.scrollTop + (cardRect.top - containerRect.top) - 10;

				container.scrollTo({
					top: scrollTop,
					behavior: "smooth",
				});

				// 🔓 unlock after scroll ends
				setTimeout(() => {
					this.isAutoScrolling = false;
				}, 500); // adjust if needed
			});
		},
		async getparticularMockInterviewData() {
			try {
				const interviewID = this.$route.query.interviewId;
				const response = await particularMockInterviewData(interviewID);
				if (response.status == 200) {
					this.LoaderStatus = false;
					this.mockinterviewData = response.data.data.details.questionReports;
					this.mockintMetaData = response.data.data.details;
				}
			} catch (error) {
				console.log("error");
			}
		},
		formatDateTime(dateStr) {
			if (!dateStr) return "";

			// Parse as UTC
			const utcDate = new Date(dateStr);

			// Convert to IST (+5:30)
			const istOffset = 5.5 * 60 * 60 * 1000;
			const istDate = new Date(utcDate.getTime() + istOffset);

			const day = String(istDate.getDate()).padStart(2, "0");
			const month = String(istDate.getMonth() + 1).padStart(2, "0");
			const year = istDate.getFullYear();

			let hours = istDate.getHours();
			const minutes = String(istDate.getMinutes()).padStart(2, "0");
			const ampm = hours >= 12 ? "PM" : "AM";

			hours = hours % 12 || 12;

			return `${day}.${month}.${year}, ${hours}:${minutes} ${ampm}`;
		},
	},
};
</script>

<style>
.re-interview-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 0px 0px 0px 60px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.re-interview-container .top-row {
	background-color: #fafafa;
	padding: 15px 20px;
	border-bottom: 1px solid #d7d9db;
	transition: all 0.3s ease;
	max-height: 100px;
	overflow: hidden;
	opacity: 1;
}
.re-interview-container .top-row.collapsed {
	max-height: 0;
	padding: 0 20px;
	border-bottom: none;
	opacity: 0;
}
.re-interview-container .second-row {
	background: #f7f9fc;
	border-radius: 0px 0px 8px 8px;
	width: 100%;
	overflow-x: auto;
	padding: 15px 20px;
	transition: margin-top 0.3s ease;
}
.second-row::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.re-interview-container .second-row article {
	border: 1px solid #20639b;
	background-color: #fff;
	border-radius: 16px;
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #2e425d;
	padding: 4px 10px;
	cursor: pointer;
	white-space: nowrap;
}
.re-interview-container .second-row article.selected {
	background-color: #20639b;
	color: #fff;
	font-weight: 600;
}
.question-overlfow {
	width: 100%;
	margin-top: 15px;
	overflow: auto;
	padding-inline: 15px;
	transition: height 0.3s ease;
}
.question-overlfow .ques-card {
	background-color: #fff;
	border-radius: 16px;
	padding: 16px;
	margin-bottom: 15px;
}
.question-overlfow .dashed-div {
	border-bottom: 1px dashed #c5c5c5;
	height: 20px;
	margin-bottom: 20px;
}
.question-overlfow .dashed-div-2 {
	border-bottom: 2px dashed #72738e3b;
	height: 15px;
	margin-bottom: 10px;
}
.question-overlfow .answer-card {
	background-color: #f7f9fc;
	border-radius: 8px;
	padding: 16px;
}
.question-overlfow .line {
	flex: 1;
	height: 1px;
	background-color: #8c8c8c54;
}
.question-overlfow .strength {
	background-color: #f0fdf4;
	padding: 16px;
	border-radius: 8px;
	flex: 1;
}
.question-overlfow .weakness {
	background-color: #f3f6ff;
	padding: 16px;
	border-radius: 8px;
	flex: 1;
}

.question-overlfow .clarification {
	background-color: #fff6ed;
	padding: 16px;
	border-radius: 8px;
	flex: 1;
}
@media (max-width: 1028px) {
	.re-interview-container {
		background-color: #f5f9ff;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		) !important;
		padding: 0px !important;
		overflow: auto !important;
		position: fixed !important;
		top: unset !important;
		display: unset !important;
	}
	.re-interview-container .top-row {
		background-color: #fff;
	}
	.re-interview-container {
		background-color: #e9ecef;
	}
	.question-overlfow .img-1 {
		height: 16px;
	}
	.ques-hor-scroll {
		width: 100%;
		overflow-x: auto;
	}
	.question-overlfow .ques-card {
		padding-bottom: 5px;
	}
}
.color-aborted {
	color: #e70016;
}
</style>
